/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { getParentRouteUrl, getRouteInitData } from '@gh/common-shared';
import { STYLES_FLEX_COLUMN_LAYOUT } from '@gh/core-ui';

import { assign } from 'lodash';

import { RfqGeneral } from '../../resources/lead.model';

@Component({
  selector: 'gh-lead-details-rfq-tab',
  template: require('./rfq-tab-container.component.html'),
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
})
export class RfqTabContainerComponent implements OnInit {
  salesFolder: RfqGeneral;
  queryParams: Params;

  constructor(private route: ActivatedRoute) {
  }

  get parentRoute(): string {
    return getParentRouteUrl(this.route);
  }

  ngOnInit(): void {
    const { ...init } = getRouteInitData(this.route);

    this.queryParams = this.route.snapshot.queryParams;
    assign(this, init);
  }
}
